// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "dist/css/" + chunkId + "." + {"151":"ec74e4fa","466":"3220935e"}[chunkId] + ".css";
};